import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Toolbar from '@mui/material/Toolbar';
import { Col, Image, Row, Stack } from 'react-bootstrap';
import 'components/sidebar/sidebar.scss';
import 'assets/styles/common.scss';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import ToastNotification from 'components/common/Toast';
import { LocaleContext } from 'routes/Router';
import {
  getLandingURL,
  providerAdminAppointments,
  providerAdminBranches,
  providerAdminCategory,
  providerAdminCustomer,
  providerAdminDashboard,
  providerAdminProfile,
  providerAdminSpecialists,
  superAdminAppointments,
  superAdminCampaigns,
  superAdminCategory,
  superAdminCoupons,
  superAdminCustomer,
  superAdminDashboard,
  superAdminProvider,
} from 'routes/AppUrls';
import { FormattedMessage, useIntl } from 'react-intl';
import Dashboard from 'assets/images/sidebar/dashboard.png';
import DashboardColor from 'assets/images/sidebar/dashboardColor.png';
import Provider from 'assets/images/sidebar/Provider.png';
import ProviderColor from 'assets/images/sidebar/ProviderColor.png';
import Customer from 'assets/images/sidebar/Customer.png';
import CustomerColor from 'assets/images/sidebar/CustomerColor.png';
import Profile from 'assets/images/sidebar/Profile.png';
import ProfileColor from 'assets/images/sidebar/ProfileColor.png';
import Service from 'assets/images/sidebar/Service.png';
import ServiceColor from 'assets/images/sidebar/ServiceColor.png';
import Appointment from 'assets/images/sidebar/Appointment.png';
import AppointmentColor from 'assets/images/sidebar/AppointmentColor.png';
import Branches from 'assets/images/sidebar/Branches.png';
import BranchesColor from 'assets/images/sidebar/BranchesColor.png';
import Specialist from 'assets/images/sidebar/Specialist.png';
import SpecialistColor from 'assets/images/sidebar/SpecialistColor.png';
import Campaign from 'assets/images/sidebar/Campaign.png';
import CampaignColor from 'assets/images/sidebar/CampaignColor.png';
import Coupon from 'assets/images/sidebar/CallBell-1.png';
import CouponColor from 'assets/images/sidebar/CallBell.png';
import Logout from 'assets/images/sidebar/logout.png';
import { ReactComponent as appointmentsvg } from 'assets/images/sidebar/appointmentsvg.svg';
import { ReactComponent as branchessvg } from 'assets/images/sidebar/branchessvg.svg';
import { ReactComponent as dashboardsvg } from 'assets/images/sidebar/dashboardsvg.svg';
import { ReactComponent as customersvg } from 'assets/images/sidebar/customersvg.svg';
import { ReactComponent as servicesvg } from 'assets/images/sidebar/servicesvg.svg';
import { ReactComponent as specialistsvg } from 'assets/images/sidebar/specialistsvg.svg';
import { ClearTokenRedirectLogin, getUserRole } from 'utils/general';
import MenuIcon from '@mui/icons-material/Menu';
import sidebarLogo from 'assets/images/sidebar/LogoAlt.svg';
import {
  ACTIVE_INDEX,
  basicDetailsCallApi,
} from 'store/SuperAdmin/basicDetails/action';
import { useConfirm } from 'material-ui-confirm';
import { Avatar, Menu, MenuItem, IconButton } from '@mui/material';
import langIconEn from 'assets/images/navbar/arabicLangIcon.png';
import langIconAr from 'assets/images/navbar/englishLangIcon.png';
import { logoutCallAPI } from 'store/logout/action';
import LogoutIcon from '@mui/icons-material/Logout';
import PersonIcon from '@mui/icons-material/Person';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Ptext from 'components/common/Ptext';

const Sidebar = (props) => {
  const { window: muiWindow } = props;
  const intl = useIntl();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const [conf, setConf] = ToastNotification();
  const confirm = useConfirm();
  const userRole = getUserRole();
  const { locale, setLocale } = useContext(LocaleContext);
  const location = useLocation();
  const isProfilePage = location.pathname.includes('provider-profile');
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const aIndex = useSelector(
    (state) => state?.basicDetailsReducer?.activeIndex
  );
  const profileData = useSelector((state) => state?.userMeReducer?.data?.data);
  const [activeKey, setActiveKey] = useState('dashboard');
  const [openSubmenuIndex, setOpenSubmenuIndex] = useState(null);

  const pageTitle = useSelector((state) => state?.pageTitleReducer?.title);

  const LanguageSwitcher = (value) => {
    setLocale(value);
    const newUrl = window.location.pathname.replace(/^\/(en|ar)/, `/${value}`);
    window.location.href = newUrl;
  };

  const sidebarData = [
    {
      key: 'dashboard',
      name: intl.formatMessage({ id: 'Dashboard' }),
      svgIcon: dashboardsvg,
      roles: [
        'super-admin',
        'salon-admin',
        'specialist-admin',
        'company-admin',
        'branch-company',
      ],
    },
    {
      key: 'appointments',
      name: intl.formatMessage({ id: 'Appointments' }),
      svgIcon: appointmentsvg,
      roles: [
        'salon-admin',
        'specialist-admin',
        'company-admin',
        'branch-company',
      ],
    },
    {
      key: 'branches',
      name: intl.formatMessage({ id: 'Branches' }),
      svgIcon: branchessvg,
      roles: ['company-admin'],
    },
    {
      key: 'specialists',
      name: intl.formatMessage({ id: 'Specialists' }),
      svgIcon: specialistsvg,
      roles: ['salon-admin', 'company-admin', 'branch-company'],
    },
    {
      key: 'customers',
      name: intl.formatMessage({ id: 'Customers' }),
      svgIcon: customersvg,
      roles: [
        'salon-admin',
        'specialist-admin',
        'company-admin',
        'branch-company',
      ],
    },
    {
      key: 'services',
      name: intl.formatMessage({ id: 'Services' }),
      svgIcon: servicesvg,
      roles: [
        'salon-admin',
        'specialist-admin',
        'company-admin',
        'branch-company',
      ],
    },
    // SUPER ADMIN ITEMS
    {
      key: 'providers',
      name: intl.formatMessage({ id: 'Providers' }),
      icon: ProviderColor,
      selectedIcon: Provider,
      roles: ['super-admin'],
    },
    {
      key: 'super-customers',
      name: intl.formatMessage({ id: 'Customers' }),
      icon: Customer,
      selectedIcon: CustomerColor,
      roles: ['super-admin'],
    },
    {
      key: 'service-categories',
      name: intl.formatMessage({ id: 'Service Categories' }),
      icon: ServiceColor,
      selectedIcon: Service,
      roles: ['super-admin'],
    },
    {
      key: 'super-appointments',
      name: intl.formatMessage({ id: 'Appointments' }),
      icon: AppointmentColor,
      selectedIcon: Appointment,
      roles: ['super-admin'],
    },
    {
      key: 'campaigns',
      name: intl.formatMessage({ id: 'Campaigns' }),
      icon: CampaignColor,
      selectedIcon: Campaign,
      roles: ['super-admin'],
    },
    {
      key: 'coupons',
      name: intl.formatMessage({ id: 'Coupons' }),
      icon: CouponColor,
      selectedIcon: Coupon,
      roles: ['super-admin'],
    },
  ];

  const handleDrawerClose = () => {
    setIsClosing(true);
    setMobileOpen(false);
  };

  const handleDrawerTransitionEnd = () => {
    setIsClosing(false);
  };

  const handleDrawerToggle = () => {
    if (!isClosing) {
      setMobileOpen(!mobileOpen);
    }
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (text, index) => {
    setOpenSubmenuIndex(null);
    switch (text?.name) {
      case intl.formatMessage({ id: 'Dashboard' }):
        userRole === 'super-admin'
          ? navigate(superAdminDashboard(locale))
          : navigate(providerAdminDashboard(locale));
        break;
      case intl.formatMessage({ id: 'Providers' }):
        navigate(superAdminProvider(locale));
        break;
      case intl.formatMessage({ id: 'Customers' }):
        userRole === 'super-admin'
          ? navigate(superAdminCustomer(locale))
          : navigate(providerAdminCustomer(locale));
        break;
      case intl.formatMessage({ id: 'Service Categories' }):
        navigate(superAdminCategory(locale));
        break;
      case intl.formatMessage({ id: 'Services' }):
        navigate(providerAdminCategory(locale));
        break;
      case intl.formatMessage({ id: 'Profile' }):
        navigate(providerAdminProfile(locale));
        break;
      case intl.formatMessage({ id: 'Appointments' }):
        userRole === 'super-admin'
          ? navigate(superAdminAppointments(locale))
          : navigate(providerAdminAppointments(locale));
        break;
      case intl.formatMessage({ id: 'Branches' }):
        navigate(providerAdminBranches(locale));
        break;
      case intl.formatMessage({ id: 'Specialists' }):
        navigate(providerAdminSpecialists(locale));
        break;
      case intl.formatMessage({ id: 'Campaigns' }):
        navigate(superAdminCampaigns(locale));
        break;
      case intl.formatMessage({ id: 'Coupons' }):
        navigate(superAdminCoupons(locale));
        break;
      case intl.formatMessage({ id: 'Logout' }):
        navigate(handleConfirmLogOut());
        break;
    }
    setActiveKey(text.key);
    if (!isClosing) {
      setMobileOpen(!mobileOpen);
    }
    dispatch(basicDetailsCallApi(ACTIVE_INDEX, index));
  };

  const handleConfirmLogOut = () => {
    confirm({
      title: intl.formatMessage({ id: 'Confirm Logout' }),
      description: intl.formatMessage({
        id: 'Are you sure you want to Logout?',
      }),
      confirmationText: intl.formatMessage({ id: 'Logout' }),
      cancellationText: intl.formatMessage({ id: 'Cancel' }),
      dialogProps: { maxWidth: 'xs' },
      confirmationButtonProps: {
        sx: {
          bgcolor: '#292D32',
          color: '#FFFFFF',
          borderRadius: '0px',
          '&:hover': { bgcolor: '#292D32' },
        },
      },
      cancellationButtonProps: {
        sx: {
          bgcolor: 'transparent',
          color: '#292D32',
          borderRadius: '0px',
          border: '1px solid #292D32',
        },
      },
    })
      .then(() => handleLogout())
      .catch(() => console.log('Deletion cancelled.'));
  };

  const handleLogout = () => {
    dispatch(
      logoutCallAPI(
        {},
        { run: true, handleFunction: (res) => handleLogoutRedirect(res) }
      )
    );
  };

  const handleLogoutRedirect = (res) => {
    if (res?.data?.status_code === 200) {
      setConf({
        msg: intl.formatMessage({ id: 'logout successfully!' }),
        variant: 'success',
      });
      ClearTokenRedirectLogin(navigate);
    } else {
      setConf({
        msg: intl.formatMessage({ id: 'Please try again.' }),
        variant: 'error',
      });
    }
  };

  const filteredSidebarData = sidebarData.filter((item) =>
    item.roles.includes(userRole)
  );

  // ─── Drawer content ───────────────────────────────────────────────────────
  const drawer = (
    // Flex column wrapper so the bottom section sticks to the bottom
    <div className="sidebarDrawerWrapper">
      {/* Logo */}
      <Toolbar className="sidebar-logo-area flex-col justify-center pl-5 pr-5">
        <img className="w-28 h-auto" src={sidebarLogo} alt={'logo'} />
      </Toolbar>

      {/* Nav items */}
      <List className="sidebarList">
        {filteredSidebarData.map((text, index) => (
          <div key={index}>
            <ListItem
              disablePadding
              className={`mt-3 ${
                !isProfilePage && activeKey === text.key
                  ? 'borderLeftShow'
                  : 'borderLeftWithoutShow'
              }`}
            >
              <ListItemButton
                onClick={() => handleMenuItemClick(text, index)}
                className={
                  (!isProfilePage && activeKey === text.key) ||
                  (text.children && openSubmenuIndex === index)
                    ? 'active-menu-item'
                    : ''
                }
              >
                <ListItemIcon>
                  {text.svgIcon ? (
                    <text.svgIcon
                      className={`h-6 w-6 ${
                        !isProfilePage && activeKey === text.key
                          ? 'text-[#FFAE95]'
                          : 'text-[#A8A29E]'
                      }`}
                    />
                  ) : (
                    <Image
                      src={
                        (!isProfilePage && activeKey === text.key) ||
                        (text.children && openSubmenuIndex === index)
                          ? text?.selectedIcon
                          : text?.icon
                      }
                      alt="icon"
                      style={{ height: '24px', width: '24px' }}
                    />
                  )}
                </ListItemIcon>
                <Ptext
                  variant="body"
                  className={`font-medium ${!isProfilePage && activeKey === text.key ? 'text-[#ffae95]' : 'text-[#a8a29e]'}`}
                >
                  {text?.name}
                </Ptext>{' '}
              </ListItemButton>
            </ListItem>
          </div>
        ))}
      </List>

      {/* ── Bottom: Language switcher ───────────────────────── */}
      <div className="sidebar-lang-switcher">
        <span
          className={`lang-option ${locale === 'en' ? 'lang-active' : ''}`}
          onClick={() => LanguageSwitcher('en')}
        >
          EN
        </span>
        <span className="lang-divider">|</span>
        <span
          className={`lang-option ${locale === 'ar' ? 'lang-active' : ''}`}
          onClick={() => LanguageSwitcher('ar')}
        >
          عربي
        </span>
      </div>
    </div>
  );

  const container =
    muiWindow !== undefined ? () => muiWindow().document.body : undefined;

  return (
    <Row>
      <Col md={0} lg={2} className="sidebar">
        <Box sx={{ display: 'flex' }}>
          {/* ── Mobile AppBar ─────────────────────────────────── */}
          <AppBar
            sx={{
              backgroundColor: '#1A1A1A',
              boxShadow: '0px 1px 0px rgba(255,255,255,0.08)',
            }}
          >
            <Toolbar className="d-xxl-none menu-container justify-content-between">
              <Stack direction="horizontal" gap={4} className="d-flex">
                <MenuIcon
                  style={{
                    fontSize: '2rem',
                    color: '#FFFFFF',
                    cursor: 'pointer',
                  }}
                  onClick={handleDrawerToggle}
                />
                <Ptext variant="heading">
                  <FormattedMessage id={pageTitle} />
                </Ptext>
              </Stack>

              <div
                className={`d-flex align-items-center ${locale === 'en' ? '' : ''}`}
              >
                <img
                  src={locale === 'en' ? langIconAr : langIconEn}
                  alt="Language Icon"
                  width="40"
                  height="40"
                  className={
                    locale === 'en'
                      ? 'mr-5 cursor-pointer'
                      : 'ml-5 cursor-pointer'
                  }
                  onClick={() =>
                    locale === 'en'
                      ? LanguageSwitcher('ar')
                      : LanguageSwitcher('en')
                  }
                />
                <div onClick={handleMenuOpen}>
                  <IconButton style={{ padding: 0 }} onClick={handleMenuOpen}>
                    {profileData?.provider_details?.profile_photo?.file_url !==
                      '' &&
                    profileData?.provider_details?.profile_photo?.file_url !==
                      undefined &&
                    profileData?.provider_details?.profile_photo?.file_url !==
                      null ? (
                      <Avatar
                        className={locale === 'en' ? 'me-3' : 'ms-3'}
                        src={
                          profileData?.provider_details?.profile_photo?.file_url
                        }
                        alt="image"
                      />
                    ) : (
                      <Avatar
                        className={locale === 'en' ? 'me-3' : 'ms-3'}
                        style={{
                          cursor: 'pointer',
                          backgroundColor: '#D8E3FF',
                          color: '#4573B9',
                        }}
                      >
                        {profileData?.email?.charAt(0)}
                      </Avatar>
                    )}
                  </IconButton>
                  <KeyboardArrowDownIcon
                    style={{ cursor: 'pointer', color: '#FFFFFF' }}
                  />
                </div>
                <div>
                  <p
                    className={`p-0 m-0 fs-14 fw-400 fc-FFFFFF ff-Akkurat ${locale === 'en' ? 'me-4' : 'ms-4'}`}
                  >
                    {profileData?.provider_details?.name}
                  </p>
                  <p
                    className={`p-0 m-0 fs-14 fw-400 fc-FFFFFF ff-Akkurat ${locale === 'en' ? 'me-4' : 'ms-4'}`}
                  >
                    {profileData?.email}
                  </p>
                </div>
              </div>
            </Toolbar>
          </AppBar>

          {/* ── Profile dropdown menu ──────────────────────────── */}
          <Menu
            open={open}
            onClose={handleMenuClose}
            anchorReference="anchorPosition"
            anchorPosition={{
              top: 60,
              left: locale === 'en' ? window.innerWidth - 10 : 10,
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: locale === 'en' ? 'right' : 'left',
            }}
            PaperProps={{
              sx: {
                mt: 1,
                borderRadius: '12px',
                width: 'auto',
                boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
                overflow: 'hidden',
              },
            }}
            sx={{ zIndex: 2200 }}
          >
            <MenuItem divider>
              <span className="fs-14 fw-400 fc-404040 ff-Akkurat">
                Hi, {profileData?.email}
              </span>
            </MenuItem>
            <MenuItem
              onClick={() => {
                navigate(providerAdminProfile(locale));
                handleMenuClose();
              }}
              className="flex items-left gap-2 mt-2"
            >
              <PersonIcon className="fs-14 fw-400 fc-404040 ff-Akkurat" />
              <span className="fs-14 fw-400 fc-404040 ff-Akkurat">
                <FormattedMessage id="My Profile" />
              </span>
            </MenuItem>
            <MenuItem
              onClick={() => {
                handleConfirmLogOut();
                handleMenuClose();
              }}
              className="flex items-left gap-2"
            >
              <LogoutIcon className="fs-14 fw-400 fc-404040 ff-Akkurat pl-2" />
              <span className="fs-14 fw-400 fc-404040 ff-Akkurat">
                <FormattedMessage id="Logout" />
              </span>
            </MenuItem>
          </Menu>

          {/* ── Drawers ───────────────────────────────────────── */}
          <Box component="nav" aria-label="mailbox folders">
            {/* Mobile: temporary */}
            <Drawer
              container={container}
              variant="temporary"
              open={mobileOpen}
              anchor={locale === 'en' ? 'left' : 'right'}
              onTransitionEnd={handleDrawerTransitionEnd}
              onClose={handleDrawerClose}
              ModalProps={{ keepMounted: true }}
              className="d-block d-xxl-none"
              sx={{
                '& .MuiDrawer-paper': {
                  boxSizing: 'border-box',
                  width: '240px',
                  backgroundColor: '#1A1A1A',
                  top: 0,
                  height: '100vh',
                },
              }}
            >
              {drawer}
            </Drawer>

            {/* Desktop: permanent */}
            <Drawer
              variant="permanent"
              anchor={locale === 'en' ? 'left' : 'right'}
              className="drawer-menu d-none d-xxl-block"
              sx={{
                '& .MuiDrawer-paper': {
                  boxSizing: 'border-box',
                  borderRight: 'none',
                  backgroundColor: '#1A1A1A',
                  top: 0,
                  height: '100vh',
                },
              }}
              open
            >
              {drawer}
            </Drawer>
          </Box>
        </Box>
      </Col>
    </Row>
  );
};

Sidebar.propTypes = {
  window: PropTypes.func,
};

export default Sidebar;
